import React from "react";
import "./style/Spinner.css";
export default (() => {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      height: "100vh"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sk-fading-circle"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sk-circle1 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle2 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle3 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle4 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle5 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle6 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle7 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle8 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle9 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle10 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle11 sk-circle"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sk-circle12 sk-circle"
  })));
});